import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOPlanningApi } from '@/api/pto'
import { priceFormat } from '@/utils/form/priceFormat'
import { mounthFormat } from '@/utils/form/mounthFormat'
import { showAlertError } from '@/utils/store/alert'
import router from '@/router'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOPlanningApi,
  namePageDetailed: 'PtoProjectPtoPlanningUpdate',
  tableHeaders: [
    {
      title: 'Год',
      isSortable: false
    },
    {
      title: 'Месяц',
      isSortable: false
    },
    {
      title: 'Объем',
      isSortable: false
    },
    {
      title: 'Рубли',
      isSortable: false
    },
    {
      title: 'Факт объем',
      isSortable: false
    },
    {
      title: 'Факт рубли',
      isSortable: false
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.year || '-',
          mounthFormat(item.month).name || '-',
          priceFormat(item.volume) || '-',
          priceFormat(item.rubles) || '-',
          priceFormat(item.fact_volume) || '-',
          priceFormat(item.fact_rubles) || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions(),

  async loadList ({ commit, state }) {
    const params = {
      expand: state.expand,
      sort: ['-year', '-month'],
      'per-page': state.pagination.perPage,
      page: state.pagination.currentPage,
      'search[job_id]': router.currentRoute.params.id
    }
    try {
      commit('SET_IS_LOADING', true)
  
      const response = await state.api.getAll(params)
  
      commit('SET_LIST', response.data.data)
      commit('SET_PAGINATION', response.headers)
    } catch (e) {
      showAlertError(e)
    } finally {
      commit('SET_IS_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
